module.exports = __webpack_public_path__ + "assets/img/qbbbook.91993433.svg";